import React, { useState, useEffect } from "react";
import { AppBar, Icon, Tab, Tabs } from "@mui/material";
import MDBox from "components/MDBox";
import breakpoints from "assets/theme/base/breakpoints";
import PropTypes from "prop-types";
import { useMaterialUIController } from "context";

function MDAppBar({ tabsInfo, tabValue, setTabValue, isSecondary }) {
  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  useEffect(() => {
    function handleTabsOrientation() {
      setTabsOrientation(window.innerWidth < breakpoints.values.md ? "vertical" : "horizontal");
    }

    window.addEventListener("resize", handleTabsOrientation);
    handleTabsOrientation();

    return () => window.removeEventListener("resize", handleTabsOrientation);
  }, []);

  const handleSetTabValue = (event, value) => {
    setTabValue(value);
  };

  return (
    <MDBox pt={0} pb={0}>
      <AppBar position="static">
        <Tabs
          orientation={tabsOrientation}
          value={tabValue}
          onChange={handleSetTabValue}
          sx={() => ({
            // eslint-disable-next-line no-nested-ternary
            backgroundColor: isSecondary
              ? darkMode
                ? "rgba(53, 65, 102, 1)"
                : "rgba(209, 208, 208, 1)"
              : darkMode
              ? "rgba(42, 52, 82, 1)"
              : "rgba(226, 226, 226, 1)",
          })}
        >
          {tabsInfo.map((tabData, index) => {
            const { label, icon } = tabData;
            return (
              <Tab
                // eslint-disable-next-line react/no-array-index-key
                key={`${label}-${index}`}
                label={label}
                icon={
                  <Icon fontSize="small" sx={{ mt: -0.25 }}>
                    {icon}
                  </Icon>
                }
              />
            );
          })}
        </Tabs>
      </AppBar>
    </MDBox>
  );
}

MDAppBar.defaultProps = {
  tabsInfo: [],
  tabValue: 0,
  isSecondary: false,
};

MDAppBar.propTypes = {
  tabsInfo: PropTypes.array,
  tabValue: PropTypes.number,
  setTabValue: PropTypes.func.isRequired,
  isSecondary: PropTypes.bool,
};

export default MDAppBar;
